import { render, staticRenderFns } from "./BrochureRequests.vue?vue&type=template&id=53b3faf7"
import script from "./BrochureRequests.vue?vue&type=script&lang=js"
export * from "./BrochureRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports